import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import StatementsOfWork from "../components/StatementsOfWork";
import * as adminActions from "./../../../../../actions/admin.actions";
import * as commonActions from "./../../../../../actions/common.actions";

const subHeader = memberId => ({
  items: [
    {
      caption: "Profile",
      url: `/admin/member/approved/${memberId}/profile`
    },
    {
      caption: "Matches",
      url: `/admin/member/approved/${memberId}/matches`
    },
    {
      caption: "Pitches",
      url: `/admin/member/approved/${memberId}/pitches`
    },
    {
      caption: "SOWs",
      url: `/admin/member/approved/${memberId}/sows`
    }
  ],

  activeItem: 3
});

class AdminMemberStatementsOfWorkContainer extends Component {
  constructor(props) {
    super(props);

    props.adminActions.getUser(this.props.match.params.memberId);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(
      subHeader(this.props.match.params.memberId)
    );
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  getMatchesWithSOWs() {
    const { matches } = this.props.admin.user;
    let matchesWithSOWs = [];

    if (matches) {
      matchesWithSOWs = _.filter(matches, match => _.get(match, "pitch.sow"));
    }

    return matchesWithSOWs;
  }

  render() {
    return <StatementsOfWork matchesWithSOWs={this.getMatchesWithSOWs()} />;
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admin
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminMemberStatementsOfWorkContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/statementsOfWork/containers/AdminMemberStatementsOfWorkContainer.js